import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { RegionOptionResource, RegionShowResource } from "../../types/region";

const baseKey = ["regions"];
const optionsKey = [...baseKey, "options"];
export const regionsService = {
	baseKey,
	getRegion: (regionId: Id | null, registrationToken: string | null) =>
		axios.get<LaravelResponse<RegionShowResource>>(keyToUrl(baseKey), {
			params: {
				regionId: regionId,
				registrationToken: registrationToken,
			},
		}),
	optionsKey,
	getRegionsOptions: () => axios.get<LaravelResponse<RegionOptionResource[]>>(keyToUrl(optionsKey)),
};
